import { render } from "./page-searchstate.vue?vue&type=template&id=edcc4634"
import script from "./page-searchstate.js?vue&type=script&lang=js"
export * from "./page-searchstate.js?vue&type=script&lang=js"

import "./page-searchstate.vue?vue&type=style&index=0&id=edcc4634&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__